export async function safeRegexExec(
  text: string,
  pattern: string,
  flags: string = 'g',
  timeoutMs: number = 5000,
): Promise<RegExpExecArray[] | null> {
  // Try to use RE2 if available (Node.js), otherwise fall back to native RegExp (browser)
  let regex: RegExp;
  if (typeof window === 'undefined') {
    try {
      const { default: RE2 } = await import('re2');
      regex = new RE2(pattern, flags) as unknown as RegExp;
    } catch (err) {
      regex = new RegExp(pattern, flags);
    }
  } else {
    // Browser: re2 is replaced with a lightweight stub via Vite alias
    const { default: RE2Stub } = await import('re2');
    regex = new RE2Stub(pattern, flags) as unknown as RegExp;
  }

  let finished = false;
  const results: RegExpExecArray[] = [];

  const timer = setTimeout(() => {
    if (!finished) {
      finished = true;
      throw new Error('Regex timeout (> ' + timeoutMs + 'ms)');
    }
  }, timeoutMs);

  try {
    let match: RegExpExecArray | null;
    while ((match = regex.exec(text)) !== null) {
      results.push(match);
    }

    if (!finished) {
      finished = true;
      clearTimeout(timer);
      return results.length > 0 ? results : null;
    }
  } catch (err) {
    if (!finished) {
      finished = true;
      clearTimeout(timer);
      throw err;
    }
  }

  return null;
}
